import crossfilter from "crossfilter2";

export default function setupCrossfilter(poems) {
  const cf = crossfilter(poems);
  const poemsDimension = {};
  const poemsGroup = {};

  function reduceAdd(p, v) {
    p.count++;
    p.items.set(v["Nr"], v);
    return p;
  }
  function reduceRemove(p, v) {
    p.count--;
    p.items.delete(v["Nr"]);
    return p;
  }
  function reduceInitial() {
    return { count: 0, items: new Map() };
  }
  function orderValue(p) {
    return p.count;
  }

  // For drawing sankey and wordcloud
  poemsDimension.theme = cf.dimension(d => d.themes, true);
  poemsGroup.theme = poemsDimension.theme
    .group()
    .reduce(reduceAdd, reduceRemove, reduceInitial)
    .order(orderValue);

  // For filtering sentiment year chart
  // Because one can select year 1900 sentiment positive and year 1905 sentiment negative
  // This requires a [year, sentiment] dimension, and can't be achieved by a year dimension and a sentiment dimension
  poemsDimension.yearSentiment = cf.dimension(d => [d.year, d.Sentiment]);
  poemsGroup.yearSentiment = poemsDimension.yearSentiment
    .group()
    .reduce(reduceAdd, reduceRemove, reduceInitial)
    .order(orderValue);

  return [cf, poemsDimension, poemsGroup];
}
